import React, { useEffect, useState } from 'react'
import Api from '../../../../_helpers/Api'
import Skeleton from 'react-loading-skeleton'
import { trans } from '../../../../_providers/Translation'
import NoDataFound from '../../../partials/NoDataFound'
import moment from 'moment'

function Files(props) {

    const [state, setState] = useState({
        loading: true,
        data: [],
    })

    useEffect(() => {
        if (props.update) {
            loadData()
        }
    }, [props.update])

    const loadData = () => {
        setState(prev => ({ ...prev, loading: true }))

        let url = 'banktransaction-files/all'

        let params = Object.entries(props.filter || {}).filter(filter => filter[1])

        if (params.length) {
            url += '?' + params.map(filter => filter[0] + '=' + encodeURIComponent(filter[1])).join('&')
        }

        Api.get(url)
            .then(res => {
                const data = res.data.items || res.data.data || (Array.isArray(res.data) ? res.data : [])

                setState(prev => ({
                    ...prev,
                    loading: false,
                    data,
                }))
            })
            .catch(() => {
                setState(prev => ({ ...prev, loading: false }))
            })
    }

    const formatPeriod = row => {
        const from = row.period_from ? moment(row.period_from) : null
        const to = row.period_to ? moment(row.period_to) : null

        if (!from && !to) {
            return '-'
        }

        if (!from || !to) {
            return (from || to).format('DD.MM.YYYY')
        }

        if (from.year() === to.year()) {
            return from.format('DD.MM') + ' - ' + to.format('DD.MM') + ' / ' + from.format('YYYY')
        }

        return from.format('DD.MM.YYYY') + ' - ' + to.format('DD.MM.YYYY')
    }

    return (
        <>
            <h2 style={{ marginTop: '25px', marginBottom: '10px', fontSize: '16px', fontWeight: 600, color: '#1e1b39' }}>
                {trans('tables.files')}
            </h2>

            {state.loading
                ? <Skeleton height={35} count={5} />
                : state.data.length === 0
                    ? <NoDataFound />
                    : <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '50px' }}>ID</th>
                                    <th>{trans('tables.forPeriod')}</th>
                                    <th>{trans('tables.uploadedAt')}</th>
                                    <th>{trans('tables.nameOfFile')}</th>
                                    <th>{trans('tables.employee')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.map(row => (
                                    <tr key={row.id}>
                                        <td style={{ width: '50px' }}>{row.id}</td>
                                        <td style={{ whiteSpace: 'nowrap' }}>{formatPeriod(row)}</td>
                                        <td>{row.created_at ? moment(row.created_at).format('DD.MM.YYYY / HH:mm') : '-'}</td>
                                        <td>
                                            {row.path
                                                ?
                                                <a href={`${process.env.REACT_APP_API_URL}/storage/${row.path.replace('public/', '')}`} target="_blank" rel="noreferrer">
                                                    {row.filename || row.name}
                                                </a>
                                                :
                                                row.filename || row.name || '-'
                                            }
                                        </td>
                                        <td>
                                            {row.user
                                                ? `${row.user.name || ''} ${row.user.lastname || ''}`.trim()
                                                : row.employee
                                                    ? `${row.employee.name || ''} ${row.employee.lastname || ''}`.trim()
                                                    : '-'
                                            }
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
            }
        </>
    )
}

export default Files
